<template>
    <div class="basic-section" :class="{moreWidth: pageIndex == 3 || pageIndex == 4}">
        <div class="border-list" v-if="pageIndex == 1">
            <el-form
                ref="profileForm"
                :model="_collectModels.profileForm"
                :rules="profileRules"
                :label-position="'left'"
                label-width="155px"
            >
                <el-form-item :label="dataSource.profileLabels.first_name" prop="first_name">
                    <el-input
                        v-model="_collectModels.profileForm.first_name"
                        :placeholder="dataSource.profileLabels.placeholder"
                    ></el-input>
                </el-form-item>
                <el-form-item :label="dataSource.profileLabels.last_name" prop="last_name">
                    <el-input
                        v-model="_collectModels.profileForm.last_name"
                        :placeholder="dataSource.profileLabels.placeholder"
                    ></el-input>
                </el-form-item>
                <el-form-item :label="dataSource.profileLabels.birth" prop="birth">
                    <el-date-picker
                        v-model="_collectModels.profileForm.birth"
                        align="right"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder
                        :picker-options="pickerOptions"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item :label="dataSource.profileLabels.gender" prop="gender">
                    <el-select v-model="_collectModels.profileForm.gender" placeholder>
                        <el-option
                            v-for="item in dataSource.gender"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="dataSource.profileLabels.cityResidence" prop="cityResidence">
                    <el-input
                        v-model="_collectModels.profileForm.cityResidence"
                        :placeholder="dataSource.profileLabels.placeholder"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    :label="dataSource.profileLabels.nationalityName"
                    prop="nationalityName"
                >
                    <el-select v-model="_collectModels.profileForm.nationality" placeholder>
                        <el-option
                            v-for="(item, index) in dataSource.nationalities"
                            :key="index"
                            :label="item.name"
                            :value="item.code2"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="dataSource.profileLabels.currency" prop="currency">
                    <el-select v-model="_collectModels.profileForm.currency" placeholder>
                        <el-option
                            v-for="item in dataSource.currencies"
                            :key="item.value"
                            :label="item.description"
                            :value="item.code"
                        ></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
        </div>

        <div class="checkPic-list" v-if="pageIndex == 2">
            <ul>
                <li
                    v-for="(item, index) in dataSource.w100_pic_list"
                    :key="index"
                    :value="item.value"
                    @click="singleSelect(item, 'w100_pic_list', 'investment_interests')"
                    class="checkPic-w100-item"
                >
                    <img :src="item.pic" :alt="item.title" />
                    <div class="mask" :class="{checked: item.selected}">
                        <h4>{{item.title}}</h4>
                    </div>
                </li>
            </ul>
        </div>

        <div class="checkPic-list" v-if="pageIndex == 3">
            <ul>
                <li
                    v-for="(item, index) in dataSource.w33_pic_list.areas"
                    :key="index"
                    :value="item.id"
                    :class="{checked: item.selected}"
                    class="checkPic-w50-item"
                    @click="multipleSelect(item, 'w33_pic_list', 1, 3, 'area_interests')"
                >
                    <img :src="item.picture" :alt="item.name" />
                    <div class="mask" :class="{checked: item.selected}">
                        <h4>{{item.name}}</h4>
                    </div>
                </li>
            </ul>
        </div>

        <div class="checkPic-list" v-if="pageIndex == 4">
            <ul>
                <li
                    v-for="(item, index) in dataSource.cities"
                    :key="index"
                    :value="item.id"
                    class="checkPic-w33-item"
                    @click="multipleSelect(item, 'cities', 3, 100, 'investments')"
                >
                    <img :src="item.picture" :alt="item.name" />
                    <div class="mask" :class="{checked: item.selected}">
                        <h4>{{item.name}}</h4>
                        <p>{{item.country_name}}</p>
                    </div>
                </li>
            </ul>
        </div>

        <div class="border-list budget-list" v-if="pageIndex == 5">
            <el-form ref="budgetForm" :model="_collectModels.budgetForm">
                <el-form-item v-for="item in dataSource.budget_list" :key="item.id">
                    <div class="budget-wrapper">
                        <div class="budget-city">
                            {{$t('UJ.section5.budget')}}
                            <span>{{item.name}}, {{item.country_name}}</span>
                        </div>
                        <div class="budget-price">
                            <span
                                class="budget-currency"
                            >{{defaultSetting.currency_code}} {{defaultSetting.currency_symbol}}</span>
                            <numeric-input
                                type="number"
                                v-model="item.average_price"
                                @change="changeBudget(item)"
                            ></numeric-input>
                            <!-- <el-input
                                type="number"
                                v-model="item.average_price"
                                @change="changeBudget(item)"
                            ></el-input>-->
                        </div>
                    </div>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
let ujInvestmentReturns1 = require("../../../../website_20/static/img/UJ/uj-investment-returns1@2x.png");
let ujInvestmentReturns2 = require("../../../../website_20/static/img/UJ/uj-investment-returns2@2x.png");
let ujInvestmentReturns3 = require("../../../../website_20/static/img/UJ/uj-investment-returns3@2x.png");
let ujInvestmentReturns4 = require("../../../../website_20/static/img/UJ/uj-investment-returns4@2x.png");
let ujInvestmentReturns5 = require("../../../../website_20/static/img/UJ/uj-investment-returns5@2x.png");

import numericInput from "@/components/common/numeric-input.vue";

export default {
    name: "UJSection1",

    props: {
        pageIndex: {},
        goToNextSection: { type: Boolean },
        requestParams: {},
        nationalities: {},
        currencies: {},
        defaultSetting: {},
        collectModels: {}
    },

    data() {
        const $t = this.$t.bind(this);
        return {
            dataSource: {
                profileLabels: {
                    first_name: $t("UJ.first_name"),
                    last_name: $t("UJ.last_name"),
                    birth: $t("UJ.birth"),
                    gender: $t("UJ.gender"),
                    cityResidence: $t("UJ.cityResidence"),
                    nationalityName: $t("UJ.nationalityName"),
                    currency: $t("UJ.currency"),
                    placeholder: $t("UJ.placeholder")
                },

                w100_pic_list: [
                    {
                        title: $t("UJ.section2.buyProperty1"),
                        value: "RETURNS_2_5_YEARS",
                        pic: ujInvestmentReturns1,
                        selected: false
                    },
                    {
                        title: $t("UJ.section2.buyProperty2"),
                        value: "RETIREMENT",
                        pic: ujInvestmentReturns2,
                        selected: false
                    },
                    {
                        title: $t("UJ.section2.buyProperty3"),
                        value: "VACATION",
                        pic: ujInvestmentReturns3,
                        selected: false
                    },
                    {
                        title: $t("UJ.section2.buyProperty4"),
                        value: "SECOND_HOME",
                        pic: ujInvestmentReturns4,
                        selected: false
                    },
                    {
                        title: $t("UJ.section2.buyProperty5"),
                        value: "PRIMARY_HOME",
                        pic: ujInvestmentReturns5,
                        selected: false
                    }
                ],

                w33_pic_list: {},

                budget_list: [],

                gender: [
                    {
                        value: "F",
                        label: $t("UJ.genderOptions.female")
                    },
                    {
                        value: "M",
                        label: $t("UJ.genderOptions.male")
                    }
                ],

                cities: [],
                nationalities: [],
                currencies: []
            },

            _collectModels: {},

            profileRules: {
                first_name: [
                    {
                        required: true,
                        message: $t("UJ.errorMsg.first_name"),
                        trigger: "blur"
                    }
                ],
                last_name: [
                    {
                        required: true,
                        message: $t("UJ.errorMsg.last_name"),
                        trigger: "blur"
                    }
                ],
                birth: [
                    {
                        required: true,
                        message: $t("UJ.errorMsg.birth"),
                        trigger: "blur"
                    }
                ],
                gender: [
                    {
                        required: true,
                        message: $t("UJ.errorMsg.gender"),
                        trigger: "blur"
                    }
                ],
                cityResidence: [
                    {
                        required: true,
                        message: $t("UJ.errorMsg.cityResidence"),
                        trigger: "blur"
                    }
                ],
                nationalityName: [
                    {
                        required: true,
                        message: $t("UJ.errorMsg.nationalityName"),
                        trigger: "blur"
                    }
                ],
                currency: [
                    {
                        required: true,
                        message: $t("UJ.errorMsg.currency"),
                        trigger: "blur"
                    }
                ]
            },

            globalParams: {
                currencySymbol: {}
            },

            pickerOptions: {
                disabledDate(time) {
                    // one year
                    const minYear = new Date().getFullYear() - 100;
                    if (minYear > time.getFullYear()) {
                        return true;
                    }
                    return time.getTime() > Date.now();
                }
            }
        };
    },

    beforeMount() {
        this._collectModels = this.collectModels;

        this.dataSource.nationalities = this.nationalities;
        this.dataSource.currencies = this.currencies;
    },

    mounted() {},

    methods: {
        // set currency
        setCurrency() {
            this.globalParams.currencySymbol = this.currencies.filter(it => {
                if (it.code == this._collectModels.profileForm.currency) {
                    return it;
                }
            });
            this.globalParams.currencySymbol = this.globalParams.currencySymbol[0];
        },

        // get user journey step
        getJourney() {
            this.$http
                .get(
                    this.requestParams.getJourney,
                    this.requestParams.requestConfig
                )
                .then(resp => {
                    this.dataSource.w33_pic_list = resp.data;
                    for (
                        let i = 0;
                        i < this.dataSource.w33_pic_list.areas.length;
                        i++
                    ) {
                        this.$set(
                            this.dataSource.w33_pic_list.areas[i],
                            "selected",
                            false
                        );
                    }
                });
        },

        getCities() {
            this.dataSource.cities = [];

            this.dataSource.w33_pic_list.areas.filter(it => {
                this._collectModels.area_interests.forEach(j => {
                    if (j == it.id) {
                        it.cities.forEach(i => {
                            this.$set(i, "selected", false);
                        });

                        this.dataSource.cities = this.dataSource.cities.concat(
                            ...it.cities
                        );
                    }
                });
            });
        },

        singleSelect(item, selectlist, target) {
            this["dataSource"][selectlist].forEach(it => (it.selected = false));
            item.selected = true;

            if (target == "investment_interests") {
                this._collectModels.investment_interests = item.value;
            }

            this.$emit("paginationNext", {
                next: true,
                _collectModels: this._collectModels
            });
        },

        multipleSelect(item, selectlist, minSelectd, maxSelected, attr) {
            if (
                !item.selected &&
                this._collectModels[attr].length < maxSelected
            ) {
                item.selected = !item.selected;
                if (attr == "area_interests") {
                    this._collectModels[attr].push(item.id);
                } else if (attr == "investments") {
                    this._collectModels[attr].push(item);
                }
            } else if (item.selected) {
                item.selected = !item.selected;
                if (attr == "area_interests") {
                    let index = this._collectModels[attr].indexOf(item.id);
                    if (index > -1) {
                        this._collectModels[attr].splice(index, 1);
                    }
                } else if (attr == "investments") {
                    let index = this._collectModels[attr].indexOf(item);
                    if (index > -1) {
                        this._collectModels[attr].splice(index, 1);
                    }
                }
            } else {
                return;
            }

            if (
                this._collectModels[attr].length >= minSelectd &&
                this._collectModels[attr].length <= maxSelected
            ) {
                this.$emit("paginationNext", {
                    next: true,
                    _collectModels: this._collectModels
                });

                if (this._collectModels.investments.length >= 3) {
                    this.dataSource.budget_list = this._collectModels.investments;
                    // this.dataSource.budget_list.forEach(it => {});
                }

                if (attr == "area_interests") {
                    this.getCities();
                }
            }
        },

        checkFields(formName) {
            let params = this.$refs[formName].model;

            this.$refs[formName].validate(valid => {
                if (!valid) return;

                this.setCurrency();

                this.$emit("paginationNext", {
                    next: true,
                    _collectModels: this.$refs[formName].model
                });
            });
        },

        changeBudget(item) {
            this._collectModels.investments.filter(it => {
                if (it.id == item.id) {
                    it.average_price = item.average_price;
                }

                this.$emit("paginationNext", {
                    next: true,
                    _collectModels: this._collectModels
                });
            });
        }
    },

    watch: {
        // nationalities: {
        //     handler(newVal, oldVal) {
        //         this.nationalities = newVal;
        //     },
        //     deep: true
        // },

        // currencies: {
        //     handler(newVal, oldVal) {
        //         this.currencies = newVal;
        //     },
        //     deep: true
        // },

        "_collectModels.profileForm": {
            handler(newVal, oldVal) {
                let hasEmpty = function(value) {
                    value.trim();
                    return value !== "";
                };
                let result = Object.values(newVal).every(hasEmpty);
                if (result) {
                    this.checkFields("profileForm");
                }
            },
            deep: true
        },

        "_collectModels.budget_list": {
            handler(newVal, oldVal) {
                // console.log(newVal);
                // let hasEmpty = function(value) {
                //     value.trim();
                //     if (value <= 1000 || value == "") {
                //         return false;
                //     }
                // };
                // let result = Object.values(newVal).every(hasEmpty);
                // if (result) {
                //     this.checkFields("budgetForm");
                // }
            }
        },

        defaultSetting: {
            handler(newVal, oldVal) {
                this.defaultSetting = newVal;
                this.getJourney();
            },
            deep: true
        }
    },

    filters: {
        NumFormat: function(val) {
            if (!val) return "0";
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
    },

    components: {
        numericInput
    }
};
</script>

<style lang="scss">
.basic-section {
    .border-list {
        .el-form-item.is-required:not(.is-no-asterisk)
            > .el-form-item__label:before {
            content: unset;
        }
        .el-form-item__content {
            text-align: right;
        }
        .el-form-item__error {
            left: unset;
            right: 0;
            color: #c00109;
        }
    }
}

@media (min-width: 768px) {
    .basic-section {
        .border-list {
            .el-form-item__error {
                left: unset;
                right: 0;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/userJourney/UJStep1.vue